import {
    BugOutlined, EllipsisOutlined, ExclamationCircleOutlined, QuestionCircleOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';

import {
    SupportTicketType, SupportTicketTypes,
} from '@/constants';

type TypeTagProps = {
    type: SupportTicketType;
};

const getTypeIcon = (type: SupportTicketType) => {
    switch (type) {
        case SupportTicketType.Bug:
            return <BugOutlined />;
        case SupportTicketType.Question:
            return <QuestionCircleOutlined />;
        case SupportTicketType.Error:
            return <ExclamationCircleOutlined />;
        case SupportTicketType.Other:
            return <EllipsisOutlined />;
        default:
            return null;
    }
};

const getTypeColor = (type: SupportTicketType): string => {
    switch (type) {
        case SupportTicketType.Bug:
            return 'orange';
        case SupportTicketType.Question:
            return 'blue';
        case SupportTicketType.Error:
            return 'red';
        case SupportTicketType.Other:
            return 'default';
        default:
            return 'default';
    }
};

export const TypeTag = ({ type }: TypeTagProps) => {
    const color = getTypeColor(type);
    const label = SupportTicketTypes[type];
    const icon = getTypeIcon(type);

    return (
        <Tag color={color} icon={icon}>
            {label}
        </Tag>
    );
};
